module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPHBhdGggZmlsbD0iIzBkYjAyYiIgZD0iTTAgMGg2NDB2NDgwSDB6Ii8+CiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMGg2NDB2MzIwSDB6Ii8+CiAgPHBhdGggZmlsbD0iI2UwNTIwNiIgZD0iTTAgMGg2NDB2MTYwSDB6Ii8+CiAgPGNpcmNsZSBjeD0iMzIwIiBjeT0iMjQwIiByPSI2OCIgZmlsbD0iI2UwNTIwNiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/ne.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/ne.svg
// module chunks = 0